export default "__VITE_ASSET__BOdF8gQa__"